
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenFileFormat {
    static readonly XLSX: GenFileFormat = new GenFileFormat('XLSX');
    static readonly PDF: GenFileFormat = new GenFileFormat('PDF');
    static readonly CSV: GenFileFormat = new GenFileFormat('CSV');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'XLSX') return GenFileFormat.XLSX;
        if (name === 'PDF') return GenFileFormat.PDF;
        if (name === 'CSV') return GenFileFormat.CSV;
        throw new Error('Unexpected value for GenFileFormat:' + name);
    }

    static values(): GenFileFormat[] {
        return [
            GenFileFormat.XLSX,
            GenFileFormat.PDF,
            GenFileFormat.CSV,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

